"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _immutable = require("immutable");

var _fluxActions = require("flux-actions");

var _RequestStatusTypes = _interopRequireDefault(require("settings-ui-sdk/constants/RequestStatusTypes"));

var _actions = require("./actions");

var _SitePage = _interopRequireDefault(require("./SitePage"));

var _handleActions;

var initialState = (0, _immutable.Map)({
  total: 0,
  publishedPages: (0, _immutable.OrderedMap)(),
  requestStatus: _RequestStatusTypes.default.UNINITIALIZED,
  requestStatusById: _RequestStatusTypes.default.UNINITIALIZED
});

var _default = (0, _fluxActions.handleActions)((_handleActions = {}, (0, _defineProperty2.default)(_handleActions, _actions.FetchPublishedSitePagesActionTypes.REQUEST, function (state) {
  return state.set('requestStatus', _RequestStatusTypes.default.PENDING);
}), (0, _defineProperty2.default)(_handleActions, _actions.FetchPublishedSitePagesActionTypes.SUCCESS, function (state, action) {
  var total = action.payload.data.total;
  var publishedPages = action.payload.data.objects.reduce(function (acc, page) {
    return acc.set(page.id, new _SitePage.default(page));
  }, state.get('publishedPages'));
  return state.merge({
    total: total,
    publishedPages: publishedPages,
    requestStatus: _RequestStatusTypes.default.SUCCEEDED
  });
}), (0, _defineProperty2.default)(_handleActions, _actions.FetchPublishedSitePagesByIdActionTypes.REQUEST, function (state) {
  return state.set('requestStatusById', _RequestStatusTypes.default.PENDING);
}), (0, _defineProperty2.default)(_handleActions, _actions.FetchPublishedSitePagesByIdActionTypes.SUCCESS, function (state, action) {
  var publishedPages = action.payload.data.objects.reduce(function (acc, page) {
    return acc.set(page.id, new _SitePage.default(page));
  }, state.get('publishedPages'));
  return state.merge({
    publishedPages: publishedPages,
    requestStatusById: _RequestStatusTypes.default.SUCCEEDED
  });
}), _handleActions), initialState);

exports.default = _default;
module.exports = exports.default;